<template>
	<div id="page-user-edit">
		<bread-crumbs
			v-if="activeTab === 0"
			:title="$t('Alarm.GpsAlarms')"
			:subTitle="
				($t('general.SubtitleAlarmSchedule') +
					' ' +
					$t('general.SubtitleAlarmSchedule1') +
					' ' +
					'gps' +
					' ' +
					$t('general.SubtitleAlarmSchedule2'))
					| upperAndLowerFilter
			"
			:sizeTitle="30"
			:lineHeightTitle="37"
			:sizeSubTitle="15"
			:lineHeightSubTitle="18"
		></bread-crumbs>
		<div :class="activeTab === 0 ? 'vx-card p-4' : ''">
			<div v-if="activeTab === 0" class="tab-text">
				<gps-alarm-list
					v-if="alarmReadPermission"
					@selectedAlarmEmit="selectedAlarmEmit"
					@valueCreateSchelude="valueAlarmGpsEmit"
				/>
				<not-permission v-else></not-permission>
			</div>
			<div v-else-if="activeTab === 1" class="tab-text">
				<alarm-form
					v-if="alarmCreatePermission && alarmData.key === ''"
					ref="alarmFormRef"
					:data="alarmData"
					type="AlarmGps"
					@handleSubmitEmit="handleSubmit"
					@changeActiveTabEmit="valueAlarmGpsEmit"
				/>
				<alarm-form
					v-else-if="alarmUpdatePermission && alarmData.key !== ''"
					ref="alarmFormRef"
					type="AlarmGps"
					:data="alarmData"
					:duplicate="duplicate"
					@handleSubmitEmit="handleSubmit"
					@changeActiveTabEmit="valueAlarmGpsEmit"
				/>
				<not-permission v-else></not-permission>
			</div>
		</div>
	</div>
</template>

<script>
import moduleAlarm from "@/store/alarm/moduleAlarm.js";
import AlarmGps from "@/models/AlarmGps";
import GpsAlarmList from "./GpsAlarmList.vue";
import AlarmForm from "../AlarmForm.vue";
import NotPermission from "@/views/pages/NotPermission.vue";

export default {
	components: {
		GpsAlarmList,
		AlarmForm,
		NotPermission,
	},
	data() {
		return {
			alarmData: new AlarmGps({}),
			activeTab: 0,
			duplicate: false,
		};
	},
	computed: {
		nameTabOne() {
			return this.alarmData.key !== "" ? this.$t("Alarm.UpdateAlarm") : this.$t("Alarm.CreateAlarm");
		},
		alarmReadPermission() {
			return this.$store.getters.checkPermission("ALARMS_R");
		},
		alarmCreatePermission() {
			return this.$store.getters.checkPermission("ALARMS_C");
		},
		alarmUpdatePermission() {
			return this.$store.getters.checkPermission("ALARMS_U");
		},
	},
	watch: {
		activeTab(tabNum) {
			if (tabNum === 0) {
				this.alarmData = new AlarmGps({});
			}
		},
	},
	methods: {
		selectedAlarmEmit(alarm, duplicate = false) {
			this.alarmData = new AlarmGps(alarm);
			this.activeTab = 1;
			this.duplicate = duplicate;
		},
		valueAlarmGpsEmit(val) {
			this.activeTab = val;
			if (this.activeTab === 0) {
				this.alarmData = new AlarmGps({});
			}
		},
		handleSubmit(data, update, duplicate = false) {
			this.alarmData = data;
			this.$refs.alarmFormRef.openLoadingBtn();
			if (update && !duplicate) {
				this.$store
					.dispatch("moduleAlarm/updateGpsAlarm", this.alarmData)
					.then((res) => {
						this.valueAlarmGpsEmit(0);
						this.$vs.notify({
							color: "success",
							title: this.$t("Alarm.TitleConfirmAlarmUpdate"),
							text: this.$t("Alarm.TextConfirmAlarmUpdate"),
						});
						this.$refs.alarmFormRef.closeLoadingBtn();
					})
					.catch((err) => {
						this.$refs.alarmFormRef.closeLoadingBtn();
						this.$vs.notify({
							color: "danger",
							title: this.$t("ErrorTitle"),
							text: this.$t("ErrorMessage"),
						});
						throw new Error(err);
					});
			} else {
				delete this.alarmData.key;
				delete this.alarmData.company_id;
				delete this.alarmData.created_at;
				this.$store
					.dispatch("moduleAlarm/createGpsAlarm", this.alarmData)
					.then((res) => {
						this.$vs.notify({
							color: "success",
							title: this.$t("Alarm.TitleConfirmAlarmCreate"),
							text: this.$t("Alarm.TextConfirmAlarmCreate"),
						});
						this.valueAlarmGpsEmit(0);
						this.$refs.alarmFormRef.closeLoadingBtn();
					})
					.catch((err) => {
						this.$refs.alarmFormRef.closeLoadingBtn();
						this.$vs.notify({
							color: "danger",
							title: this.$t("ErrorTitle"),
							text: this.$t("ErrorMessage"),
						});
						throw new Error(err);
					});
			}
		},
	},
	created() {
		if (!moduleAlarm.isRegistered) {
			this.$store.registerModule("moduleAlarm", moduleAlarm);
			moduleAlarm.isRegistered = true;
		}
	},
};
</script>
